export default "__VITE_ASSET__99ff757a__"